import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-input__label" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "disabled", "value", "placeholder"]

import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';

// v-modelでバインドする

export default /*@__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    modelValue: {},
    label: {},
    isError: { type: Boolean },
    errorMessage: {},
    placeholder: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

/**
 * 入力イベントを親コンポーネントに通知します。
 * @param event - 入力イベント
 */
const onInput = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.label !== '')
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: `unmanaged-business-${_ctx.label}`,
            class: "text-input__label-text"
          }, _toDisplayString(_ctx.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode(ErrorMessage, {
        "is-error": _ctx.isError,
        "error-message": _ctx.errorMessage
      }, null, 8, ["is-error", "error-message"])
    ]),
    _createElementVNode("input", {
      id: `unmanaged-business-${_ctx.label}`,
      disabled: props.disabled,
      class: _normalizeClass(["text-input", { 'text-input__is-error': _ctx.isError }]),
      type: "text",
      value: props.modelValue,
      placeholder: _ctx.placeholder,
      onInput: onInput
    }, null, 42, _hoisted_3)
  ]))
}
}

})